import ImageGallery from "../components/image-gallery";
export default function ImageGalleryPage() {
    return (
        <main style={{ padding: "1rem 0" }}>
          <ImageGallery></ImageGallery>
        </main>
      );
};